module.exports = __webpack_public_path__ + "img/gather_sleeve_opening.07482b50.png";